<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="mb-2">
            <a href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#leave_type_modal" v-can="'LeaveTypes.Create'">
              <i class="ti ti-circle-plus me-2"></i>Add Leave Type
            </a>
          </div>
          <div class="head-icons ms-2">
            <a href="javascript:void(0);" id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row g-2 align-items-end">
            <div class="col-md-4">
              <label class="form-label">Search</label>
              <input v-model="store.filters.search" type="text" class="form-control" placeholder="Name / Code" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Enabled</label>
              <select v-model="store.filters.enabled" class="form-select">
                <option value="">All</option>
                <option value="1">Enabled</option>
                <option value="0">Disabled</option>
              </select>
            </div>
            <div class="col-md-2 d-grid">
              <button class="btn btn-primary" @click="store.fetchAll({ page: 1 })">Filter</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5 class="d-flex align-items-center">Leave Types</h5>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Code</th>
                  <th>Default Days/Yr</th>
                  <th>Carry Forward</th>
                  <th>Max CF Days</th>
                  <th>Paid</th>
                  <th>Enabled</th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in store.items" :key="t.id">
                  <td>{{ t.name }}</td>
                  <td><span class="badge bg-light text-dark">{{ t.code }}</span></td>
                  <td>{{ t.default_days }}</td>
                  <td>
                    <span class="badge" :class="t.carry_forward ? 'bg-success' : 'bg-secondary'">
                      {{ t.carry_forward ? 'Yes' : 'No' }}
                    </span>
                  </td>
                  <td>{{ t.carry_forward_max ?? '-' }}</td>
                  <td>
                    <span class="badge" :class="t.paid ? 'bg-success' : 'bg-secondary'">
                      {{ t.paid ? 'Paid' : 'Unpaid' }}
                    </span>
                  </td>
                  <td>
                    <div class="form-check form-switch m-0">
                      <input class="form-check-input" type="checkbox" :checked="t.is_enabled"
                             @change="store.toggleEnabled(t.id, $event.target.checked)" v-can="'LeaveTypes.Edit'" />
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="action-icon d-inline-flex">
                      <a href="javascript:void(0);" class="me-2" @click="openEdit(t)" v-can="'LeaveTypes.Edit'">
                        <i class="ti ti-edit"></i>
                      </a>
                      <a href="javascript:void(0);" @click="confirmDelete(t)" v-can="'LeaveTypes.Delete'">
                        <i class="ti ti-trash"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr v-if="!store.loading && !store.items.length">
                  <td colspan="8" class="text-center text-muted py-4">No leave types found.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="p-3 d-flex justify-content-between align-items-center">
            <div>Showing page {{ store.pagination.current_page }} of {{ totalPages }}</div>
            <div class="btn-group">
              <button class="btn btn-outline-secondary" :disabled="store.pagination.current_page <= 1"
                      @click="store.fetchAll({ page: store.pagination.current_page - 1 })">Prev</button>
              <button class="btn btn-outline-secondary" :disabled="store.pagination.current_page >= totalPages"
                      @click="store.fetchAll({ page: store.pagination.current_page + 1 })">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between bg-white border-top p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a></p>
    </div>
  </div>

  <leave-type-modal :edit-item="editItem" @saved="onSaved" />
</template>

<script setup>
import { computed, onMounted, ref, nextTick } from "vue";
import { useLeaveTypeStore } from "@/stores/leaveTypeStore";
import LeaveTypeModal from "@/components/modal/leave-type-modal.vue";
import Modal from "bootstrap/js/dist/modal";

const title = "Leave Settings";
const text = "HR";
const text1 = "Leave Settings";

const store = useLeaveTypeStore();
const editItem = ref(null);
let editModal;

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function getOrCreateModal(el) {
  if (!el) return null;
  return Modal.getOrCreateInstance(el, { backdrop: true, keyboard: true });
}

const totalPages = computed(() => {
  const t = store.pagination.total || 0;
  const p = store.pagination.per_page || 25;
  return Math.max(1, Math.ceil(t / p));
});

function openEdit(row) {
  editItem.value = row;
  nextTick(() => {
    const el = document.getElementById("leave_type_modal");
    editModal = getOrCreateModal(el);
    editModal?.show();
  });
}

// async function confirmDelete(row) {
//   if (!confirm(`Delete leave type "${row?.name}"?`)) return;
//   await store.remove(row.id);
// }


async function confirmDelete(row) {
  editItem.value = row;
   nextTick(() => {
    const el = document.getElementById("delete_modal");
    editModal = getOrCreateModal(el);
    editModal?.show();
  });
}


function onSaved() {
  editItem.value = null;
}

onMounted(() => {
  store.fetchAll();
    const editEl = document.getElementById("leave_type_modal");
  editEl?.addEventListener("hidden.bs.modal", () => {
    editItem.value = null;
  });
});
</script>


